import(/* webpackMode: "eager" */ "/vercel/path0/components/ButtonCheckout.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/FAQ.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/FeaturesAccordion.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Header.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/public/logos/main_logo.svg")